import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllProjects = async ({
  companyCode,
  isTrue = true,
  locationCode,
  isAllCompanies = false,
  userId = 0,
  selectedCompanyCode = "",
}) => {
  if (!companyCode) {
    return [];
  }

  let queryParams = `?isAllCompanies=${isAllCompanies}&isAll=true&isTrue=${isTrue}&CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}`;

  if (isAllCompanies && userId) {
    queryParams += `&UserId=${userId}`;
  }

  if (
    locationCode !== undefined &&
    locationCode !== null &&
    locationCode !== ""
  ) {
    queryParams += `&LocationCode=${locationCode}`;
  }
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAllProject}${queryParams}`,
  );
  return data;
};

const getProjectById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetProject}?CompanyCode=${companyCode}&ProjectId=${code}`,
  );
  return data;
};

const insertProject = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.InsertProject, input);
  return data;
};

const updateProject = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.UpdateProject, input);
  return data;
};

const deleteProject = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.DeleteProject}?CompanyCode=${companyCode}&ProjectId=${code}`,
  );
  return data;
};

export const useGetProjectsQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllProject],
    queryFn: () => getAllProjects(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetProjectByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllProject],
    queryFn: () => getProjectById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertProjectMutation = () => {
  return useMutation({
    mutationFn: insertProject,
  });
};

export const useUpdateProjectMutation = () => {
  return useMutation({
    mutationFn: updateProject,
  });
};

export const useDeleteProjectMutation = () => {
  return useMutation({
    mutationFn: deleteProject,
  });
};
